import { VolleyballIncidentId } from '@collector/sportsapi-client-legacy'

export const VolleyballManualAddIncidentIds = [
  VolleyballIncidentId.Serve,
  VolleyballIncidentId.NeutralAttack,
  VolleyballIncidentId.Reception,
  VolleyballIncidentId.Set,
  VolleyballIncidentId.Dig,
]

export const VolleyballManualAddIncidentSubstitutionIds = []
